<misc-collapsible-panel>
    <span slot="title">{{form.name}}</span>
    <question v-for="question in form.questions" :key="question.id" :question="question"/>
</misc-collapsible-panel>  